import { render, staticRenderFns } from "./MobileCustomInstructions.vue?vue&type=template&id=45f81142&scoped=true"
import script from "./MobileCustomInstructions.vue?vue&type=script&lang=js"
export * from "./MobileCustomInstructions.vue?vue&type=script&lang=js"
import style0 from "./MobileCustomInstructions.vue?vue&type=style&index=0&id=45f81142&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f81142",
  null
  
)

export default component.exports